import { FC, useContext } from "react";
import FooterText from "../../components/footerText";
import AuthSubHeader from "../../components/authSubHeader";
import { AuthContext } from "src/context/authContext";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import ManufacturerContactAndSafetyInfo from "src/components/manufacturer/manufacturerContactAndSafetyInfo";



const CopayEnrollment: FC = (): JSX.Element => {

  const { isManufacturer, isUserAuthorized } = useContext(AuthContext);

  return (
      <div className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
          {isUserAuthorized &&
              <div className="bg-mist py-2">
                  <div className="container-fluid">
                      {isManufacturer ?
                          <ManufacturerContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} /> :
                          <AuthSubHeader />
                      }
                  </div>
              </div>
          }
          <div className="container py-5 d-flex flex-column flex-fill copay-modal" style={{maxWidth: "1200px"}}>
              <h3 className="color-orange">ZILRETTA Co-Pay Program</h3>
              <h6 className="mb-4 fw-semibold">
                  The ZILRETTA Co-Pay Program allows eligible patients to pay as little as $0 up to a maximum benefit
                  of $1,000 per calendar year.
              </h6>
              <h5 className="color-primary fw-semibold">Eligibility Guidelines</h5>
              <p>
                  To be eligible for the ZILRETTA Co-Pay Program a patient must be a) 18 years of age or older b) a
                  citizen or permanent resident of the United States c) have an on-label diagnosis from their healthcare
                  provider d) have commercial insurance and e) not hold any form of federal or state funded insurance.
                  For full Terms & Conditions of the ZILRETTA Co-Pay insurance Program <a href="https://zilretta.com/copay" target="_blank" rel="noreferrer">click here</a>
              </p>
              <h5 className="color-primary fw-semibold">Enrollment</h5>
              <p>
                  Enrollment into the ZILRETTA Co-Pay Program is easy- FlexForward will automatically enroll an eligible
                  patient into the co-pay program once a case is submitted to FlexForward. Your practice will receive an
                  Enrollment Approval Letter upon co-pay program enrollment approval.
              </p>
              <h5 className="color-primary fw-semibold">Specialty Pharmacy (SP) Dispense</h5>
              <p className="m-0">
                  If you have elected to have the Specialty Pharmacy dispense ZILRETTA, the Specialty Pharmacy will
                  process the co-pay claim and collect adjusted amount (if applicable) from the patient.
              </p>
          </div>
          <FooterText footerType="black"/>
      </div>
  );
};

export default CopayEnrollment;


